import { listMetahumanCharacterOptions } from './userContentApi';

let lookupPromise = null;

/** @param {Array<{ characterId: number|string, personaId: number, hasProfilePicture?: boolean, profilePictureRevision?: number }>} options */
export function buildCharacterOptionLookup(options) {
  const map = new Map();
  for (const option of options || []) {
    const id = String(option?.characterId ?? '').trim();
    if (id) map.set(id, option);
  }
  return map;
}

/**
 * Persona-shaped object for PatientProfileAvatar (integrated roster photo by character id).
 * @param {object} patient custom patient record
 * @param {Map<string, object>} lookup from buildCharacterOptionLookup
 */
export function profilePicturePersonaForCustomPatient(patient, lookup) {
  const characterId = String(patient?.personal?.characterId ?? '').trim();
  if (!characterId || !lookup) return null;
  const option = lookup.get(characterId);
  if (!option?.hasProfilePicture || option.personaId == null) return null;
  return {
    id: option.personaId,
    has_profile_picture: true,
    profile_picture_revision: Number(option.profilePictureRevision) || 0,
  };
}

export function loadCharacterProfilePictureLookup() {
  if (!lookupPromise) {
    lookupPromise = listMetahumanCharacterOptions()
      .then((payload) => buildCharacterOptionLookup(payload?.options))
      .catch(() => new Map());
  }
  return lookupPromise;
}

/** @visibleForTesting */
export function resetCharacterProfilePictureLookupCache() {
  lookupPromise = null;
}
